<template>
    <Dialog v-model:visible="modalVisible" header="Stripe Account Setup Required" @click.stop
        @close="userStore.toggleConnectModal" :modal="true" class="center-dialog">
        <p>To use billing features, you need to complete your Stripe account setup.</p>
        <div class="button-container">
            <Button raised label="Go to Settings" @click="goToSettings" />
        </div>
    </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
const router = useRouter();

const modalVisible = computed({
  get: () => userStore.showConnectModal,
  set: (value) => {
    userStore.showConnectModal = value;
  },
});

const goToSettings = () => {
    userStore.showConnectModal = false;
    router.push('/profile');
};
</script>

<style scoped>
.center-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.button-container {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>
